<template>
  <span>
    <span :style="style" class="resizable-avatar" v-if="!customPhoto">
      <svg
        :width="size"
        :height="size"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="12" fill="#362468" />
        <mask
          id="mask0"
          mask-type="alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24"
        >
          <circle cx="12" cy="12" r="12" fill="#362468" />
        </mask>
        <g mask="url(#mask0)">
          <circle cx="12" cy="9" r="4" fill="#D5CFF5" />
          <circle cx="12" cy="23" r="8" fill="#D5CFF5" />
        </g>
      </svg>
    </span>
    <span v-if="customPhoto">
      <div class="image-circle" :style="style">
        <img :src="customPhoto" class="custom-img" :style="style" />
      </div>
    </span>
  </span>
</template>

<script>
//Usage: <Avatar customPhoto="(photo url)"></Avatar>
export default {
  name: "Avatar",
  props: {
    customPhoto: String,
    size: {
      type: Number,
      default: 24
    }
  },
  data: () => ({}),
  computed: {
    style() {
      return `width:${this.size}px;height:${this.size}px;`;
    }
  }
};
</script>

<style lang="scss" scoped>
.resizable-avatar {
  position: relative;
}
.image-circle {
  position: relative;
  overflow: hidden;
  border-radius: 50%;
}
.custom-img {
  display: inline;
  margin: 0 auto;
  vertical-align: baseline;
}
</style>
